import React from 'react'
import { BackArrowIcon } from 'assests/GmsIcons';
import Button from 'Components/DesignSystem/Button/Button';
import Typography from 'Components/DesignSystem/Typography/Typography';

type AttributeValuesMappingHeaderProps = {
    attributeValuesCount: number | null;
    onBack: () => void;
    onDone: () => void;
}

/**
 * The attribute-values sub-view's own header.
 *
 * Back was a `<span role="button">` — no focus ring, no keyboard activation, not in
 * the tab order — and Done wore main.css's `button-style` (a baked `#091caa` fill).
 * Both are DS `Button`s now. The testids are unchanged, including Back's
 * `…-span-1`, which no longer describes its element but is what the specs select on.
 *
 * **No `tw-px-6` on the root.** `ModalHeader` already applies `!tw-px-6`; carrying a
 * second one inset this sub-header 48px while the "Recategorize" title that replaces it
 * sat at 24 — the extra whitespace reported 2026-09-13. `-ml-4` on Back cancels the
 * Button's own `px-4`, so the word starts on the same vertical as that title instead of
 * 16px further in.
 */
const AttributeValuesMappingHeader = ({ attributeValuesCount, onBack, onDone }: AttributeValuesMappingHeaderProps) => {
    return (
        <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center tw-gap-4">
                <Button
                    variant="subtle"
                    data-testid="selectattributes-attributevaluesmappingheader-span-1"
                    onClick={onBack}
                    icon={<BackArrowIcon />}
                    iconPosition="start"
                    className="tw--ml-4"
                >
                    Back
                </Button>

                <Typography variant="title-header" as="span" className="tw-text-ink">
                    {attributeValuesCount} Attribute values
                </Typography>
            </div>

            <Button
                variant="primary"
                onClick={onDone}
                data-testid="recategorize-attribute-mapping-done-btn"
            >
                Done
            </Button>
        </div>
    )
}

export default AttributeValuesMappingHeader
